<template>
    <div class="card flex-1 card-white mx-auto rounded-xl w-full order-1 md:order-0 my-4 md:my-0">
        <h1 class="text-2xl font-bold mb-8">
            Входящие Валентинки
        </h1>

        <div v-if="loaded">
            <div v-if="!items.length">
                <div>
                    <div>
                        <div class="mb-8">
                            У тебя 0 входящих Валентинок, но целая одна входящая Гонгкончанка!
                        </div>

                        <div @click="open(zoibanaItem)"
                             class="p-4 hover:bg-blue-500/10 cursor-pointer flex items-center gap-3 rounded border border-gray-500/10">
                            <svg-icon icon="arrow-through-heart-fill" class="text-pink-500 w-5 h-5 mx-auto"></svg-icon>
                            <div class="font-bold flex-1">
                                {{ zoibanaItem.subject }}
                            </div>
                            <div class="bg-orange w-2 h-2 rounded-full mx-2"></div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-else>
                <div class="mb-8">
                    У тебя
                    {{ plural(items.length, ['входящая Валентинка', 'входящих Валентинки', 'входящих Валентинок']) }}!
                </div>
                <div v-for="item in items" :key="item.id"
                     @click="open(item)"
                     class="p-4 hover:bg-blue-500/10 cursor-pointer flex items-center gap-3 rounded border border-gray-500/10">
                    <svg-icon icon="arrow-through-heart-fill"
                              class="w-5 h-5 mx-auto"
                              :class="{'text-pink-500': !item.read_at, 'text-gray-500' : item.read_at}"
                    ></svg-icon>
                    <div class=" flex-1" :class="{'font-bold': !item.read_at, 'opacity-50': item.read_at}">
                        {{ item.subject }}
                    </div>
                    <div v-if="!item.read_at" class="bg-orange w-2 h-2 rounded-full mx-2" title="Не прочитано"></div>
                    <div v-if="item.marked_as_inappropriate" class="bg-red-500 w-2 h-2 rounded-full mx-2"
                         title="Жалоба отправлена"
                    ></div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="text-center">
                Подождите, ищем ближайшего ангела
            </div>
        </div>

        <popup-modal ref="popup">
            <h2 v-if="currentItem" class="font-bold mb-4 text-xl flex items-start gap-2 leading-tight">
                <svg-icon icon="arrow-through-heart-fill" class="text-pink-500 w-5 h-5"></svg-icon>
                <div>{{ currentItem.subject }}</div>
            </h2>
            <div v-if="currentItem" class="my-4 space-y-4">
                {{ currentItem.body }}
            </div>
            <div class="flex items-center justify-between">
                <button v-if="currentItem.id && !currentItem.marked_as_inappropriate" class="btn btn-md"
                        @click.prevent="complain">
                    Пожаловаться
                </button>
                <div v-else-if="currentItem.marked_as_inappropriate" class="text-xs text-red-500">
                    Жалоба отправлена
                </div>
                <button class="btn btn-md btn-primary" @click.prevent="close">Закрыть</button>
            </div>
        </popup-modal>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import PopupModal from "../partials/PopupModal.vue";
import plural from "../../js/modules/Plural";

export default {
    components: {PopupModal},
    data() {
        return {
            loading: false,
            loaded: false,
            items: [],
            zoibanaItem: {
                subject: 'Самому классному пользователю!',
                body: 'Мы никогда тебе этого не говорили, но мы очень рады что ты пользуешься ГК, ' +
                    'не важно, пишешь ли ты посты, комменты, срешься ли, или просто заходишь время от времени. ' +
                    'Мы ценим это, очень дорожим этим, и надеемся, что наши дальнейшие отношения будут крепнуть, ' +
                    'цвести и развиваться! Чмок тебя!',
            },
            currentItem: {},
        };
    },
    mounted() {
        this.loading = true;

        Client.get('/api/v1.1/user/valentines')
            .then(response => {
                this.items = response.data.data;
            })
            .catch(error => {
                notify({
                    type: 'error',
                    text: 'Маленький ангел, доставляющий Валентики, влетел в столб. Ждите нового курьера',
                })
            })
            .finally(() => {
                this.loading = false;
                this.loaded = true;
            });
    },
    methods: {
        plural,
        open(item) {
            this.currentItem = item;
            this.$refs.popup.open();
            this.markAsRead(item);
        },
        close() {
            this.currentItem = {};
            this.$refs.popup.close();
        },
        complain() {
            if (confirm('Жалоба будет отправлена администратору, в случае если в Валентинке будет обнаружено нарушение правил, отправитель будет наказан')) {
                Client.patch('/api/v1.1/user/valentines/' + this.currentItem.id + '/inappropriate')
                    .then(() => {
                        notify({
                            type: 'success',
                            text: 'Жалоба на валентику отправлена',
                        });
                        this.items.forEach((data, index) => {
                            if (data.id === this.currentItem.id) {
                                this.items[index].marked_as_inappropriate = 1;
                            }
                        })
                    });
            }
        },
        markAsRead(item) {
            if (item.id) {
                this.items.forEach((data, index) => {
                    if (data.id === item.id) {
                        this.items[index].read_at = 1;
                    }
                })
                Client.patch('/api/v1.1/user/valentines/' + item.id + '/read');
            }
        }
    }
}
</script>